import { BlurFilter, Filter, GpuProgram, GlProgram, Texture, TexturePool } from 'pixi.js';
import vertex from '../defaults/default2.mjs';
import wgslVertex from '../defaults/default.mjs';
import fragment from './backdrop-blur-blend2.mjs';
import wgslFragment from './backdrop-blur-blend.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class BackdropBlurFilter extends BlurFilter {
  /**
   * @param options - The options of the blur filter.
   */
  constructor(options) {
    super(options);
    __publicField(this, "_blendPass");
    this.blendRequired = true;
    this.padding = 0;
    this._blendPass = new Filter({
      gpuProgram: GpuProgram.from({
        vertex: {
          source: wgslVertex,
          entryPoint: "mainVertex"
        },
        fragment: {
          source: wgslFragment,
          entryPoint: "mainFragment"
        }
      }),
      glProgram: GlProgram.from({
        vertex,
        fragment,
        name: "drop-shadow-filter"
      }),
      resources: {
        uBackground: Texture.EMPTY
      }
    });
  }
  /**
   * Override existing apply method in `Filter`
   * @override
   * @ignore
   */
  apply(filterManager, input, output, clearMode) {
    const backTexture = filterManager._activeFilterData.backTexture;
    const blurredBackground = TexturePool.getSameSizeTexture(input);
    super.apply(filterManager, backTexture, blurredBackground, true);
    this._blendPass.resources.uBackground = blurredBackground.source;
    this._blendPass.apply(filterManager, input, output, clearMode);
    TexturePool.returnTexture(blurredBackground);
  }
  updatePadding() {
    this.padding = 0;
  }
}

export { BackdropBlurFilter };
//# sourceMappingURL=BackdropBlurFilter.mjs.map
